export default "__VITE_ASSET__D0Ommz3M__"